export const sameActionTokenElements = (currentElements, nextElements) =>
    currentElements.length === nextElements.length &&
    currentElements.every((element, index) => element === nextElements[index])
